// yarn add 依赖包名
import cryptoJs from 'crypto-js'; //npm install crypto-js
import md5 from 'js-md5'; // npm install --save js-md5
import { Base64 } from 'js-base64'; // npm install --save     

//DES加密
export const encryptDes = (message, key) => {
    var keyHex = cryptoJs.enc.Utf8.parse(key)
    var option = { mode: cryptoJs.mode.ECB, padding: cryptoJs.pad.Pkcs7 }
    var encrypted = cryptoJs.DES.encrypt(message, keyHex, option)
    return encrypted.ciphertext.toString()
}

//DES解密
export const decryptDes = (message, key) => {
    var keyHex = cryptoJs.enc.Utf8.parse(key)
    var decrypted = cryptoJs.DES.decrypt(
        {
            ciphertext: cryptoJs.enc.Hex.parse(message)
        },
        keyHex,
        {
            mode: cryptoJs.mode.ECB,
            padding: cryptoJs.pad.Pkcs7
        }
    )
    return decrypted.toString(cryptoJs.enc.Utf8)
}
// Base64转码封装
export const crypto = (obj) => {
    var result = Base64.encode(JSON.stringify(obj));
    var data = encodeURI(result);
    return data;
}
// md5加密封装
export const md5Data = (cmd, data, userName) => {
    var sign_key = 'yh123321';
    var content = md5(cmd + '_' + data + '_' + '1.0_' + userName);
    var sign = md5(content + '_' + sign_key);
    return sign;
}



















